import mixpanel from 'mixpanel-browser';
mixpanel.init('31225c50c0b7ac5cd8420bda184a5e4b');

let env_check = process.env.NODE_ENV === 'production';

let actions = {
  identify: (id: string) => {
    if (env_check) mixpanel.identify(id);
  },
  alias: (id: string) => {
    if (env_check) mixpanel.alias(id);
  },
  track: (name: string, props?: any) => {
    if (env_check) mixpanel.track(name, props);
  },
  people: {
    set: (props: any) => {
      if (env_check) mixpanel.people.set(props);
    }
  }
};

export let Mixpanel = actions;
